// extracted by mini-css-extract-plugin
var _1 = "action-rcnJH";
var _2 = "bottom-L05Fq";
var _3 = "btn-XfY02";
var _4 = "description-xAMbe";
var _5 = "details-eoa3V";
var _6 = "grp-rhq16";
var _7 = "name-u1Wqq";
var _8 = "preference-MsvU3";
var _9 = "read-EJC0e";
var _a = "save-qkbq_";
var _b = "section-idE7H";
var _c = "title-qxzeb";
var _d = "top-hhF2K";
var _e = "types-dTjbn";
export { _1 as "action", _2 as "bottom", _3 as "btn", _4 as "description", _5 as "details", _6 as "grp", _7 as "name", _8 as "preference", _9 as "read", _a as "save", _b as "section", _c as "title", _d as "top", _e as "types" }
